@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.noAvailabilityContainer{
    padding: 10px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    @include breakpoints.desktop {
        margin-left: -40px;
        padding-top: 0px;
    }
    a {
        width: 85%;
    }
    button {
        @include breakpoints.desktop {
            width: 38%;
        }
    }
}

.slots {
    margin: 18px 10px 5px;
    display: flex;
    flex-flow: row wrap;
    width: 88px;
    float: left;
    border-radius: 10px;
}

.button {
    font-family: typography.$font-mont;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    white-space: nowrap;
    color: var(--white);    
    background: var(--blue-01);
    border-radius: 100px;
    margin: 16px auto 5px;
    width: 230px;
    height: 40px;
    @include breakpoints.desktop {
        width: 211px;
        min-height: 40px;
        font-size: 16px;
    }
    span {
        display: flex;
        align-items: center;
        justify-content: center;
    }
  }

.button:hover {
    background-color: var(--blue-01);
    border-color: var(--blue-01);
}

.button:active, .button:focus {
    box-shadow: none;
}
.divLabel {
    font-family: typography.$font-mont;
    font-style: normal;
    font-weight: 400;
    text-align: center;
    padding: 0 4px;
    font-size: 14px;
    line-height: 19.6px;
    letter-spacing: 0px;
    vertical-align: middle;

    @include breakpoints.desktop {
        padding: 0px;
        font-size: 14px;
        letter-spacing: 0.28px;
    }
}

.timeGroup {
    @media screen and (max-width: 991px) {
        align-items: start;
        column-gap: 16px;
        display: grid;
        grid-template-columns: 24px minmax(0, 1fr);
    }
}

.timeIcon {
    float:left;
    width: 8%;
    padding-top: 10px;

    @media screen and (max-width: 991px) {
        float: none;
        width: 24px;
    }
    img {
        width: 20px;
        @include breakpoints.desktop {
            width: auto;
        }
    }

    .eveningIcon {
        width: 10px;
        @include breakpoints.desktop {
            width: auto;
        }
    }
}

.timeSlotsContainer {
    float:left;
    width: 90%;
    margin-bottom: 20px;

    @media screen and (max-width: 991px) {
        display: grid;
        float: none;
        gap: 8px;
        grid-column: 2;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        margin: 0 0 16px;
        width: 100%;

        button {
            font-size: 12px;
            height: 32px;
            margin: 0;
            padding: 0 4px;
            width: 100%;
        }
    }
}

.officeCall {
    text-align: center;
}

.scheduleExam {
    width: calc(100% - 4px) !important;
    height: 40px !important;
    margin-top: 50px !important;
    margin-left: 2px !important;
    margin-right: 2px !important;
    clear: both;
    font-family: typography.$font-mont;
    font-weight: 600 !important;
    font-size: 14px !important;
    color: var(--white) !important;
    border-radius: 100px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-transform: none !important;

    @media screen and (max-width: 991px) {
        margin-top: 8px !important;
    }
}

.scheduleExam:disabled {
    background-color: var(--gray-01);
}
